import { showCustomImage, showCustomImageMobile } from 'globalCommon/utils/index';
import { UserLogoMap as UserMobileLogoMap } from '../common/utils/imageSource';
import { UserLogoMap } from 'pcCommon/utils/imageSource';
import commonPageService from 'mCommon/services/commonPageService';
import { syncRender } from 'globalCommon/services/syncRender';

import './style.css';

function init() {
    showCustomImage(UserLogoMap, 'customer-img');
    commonPageService({ renderAfter: syncRender });
}

init();
